import { Popup } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { memo, useCallback } from 'react';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { FormPopupContent, SuccessPopupContent } from './components';
import { useXeroAccrualManualJournalPopupIsAvailable } from './XeroAccrualManualJournalPopup.hooks';
import {
    xeroAccrualManualJournalRequestIdState,
    xeroAccrualManualJournalState,
} from './XeroAccrualManualJournalPopup.states';
import { XeroAccrualManualJournalPopupProps } from './XeroAccrualManualJournalPopup.types';

export const XeroAccrualManualJournalPopup = memo<XeroAccrualManualJournalPopupProps>((props) => {
    const { reportConfig } = props;

    const company = useCompanyBasedOnUrl();

    const [isOpen, setIsOpen] = useAtom(xeroAccrualManualJournalState);
    const [createdRequestId, setCreatedRequestId] = useAtom(xeroAccrualManualJournalRequestIdState);

    const isAvailable = useXeroAccrualManualJournalPopupIsAvailable(company, reportConfig);

    const handleToggle = useCallback(
        (open: boolean) => {
            setIsOpen(open);

            if (!open) {
                setCreatedRequestId(null);
            }
        },
        [setCreatedRequestId, setIsOpen]
    );

    if (!isAvailable) {
        return null;
    }

    return !createdRequestId ? (
        <Popup size='large' open={isOpen} onToggle={handleToggle}>
            <FormPopupContent reportConfig={reportConfig} />
        </Popup>
    ) : (
        <Popup size='xsmall' open={isOpen} onToggle={handleToggle}>
            <SuccessPopupContent reportConfig={reportConfig} requestId={createdRequestId} />
        </Popup>
    );
});

XeroAccrualManualJournalPopup.displayName = 'XeroAccrualManualJournalPopup';
